export class TeaserModel {
	label: string;
	info: string;
	id: string;
	values: any[];
	value: number;
	order: number;
	allocated: string;
	mandatory: boolean;
	type: string;
	symbol: string;
	show: string;
}

export class TeaserPostModel {
	alter: number;
	personAnrede: string;
	profilAlterRuzp: number;
	profilGvsAltersrenteMtl: number;
	einkommenNekG: number;
	gewuenschteRente: number;
	inflation: number;
	steigerungGes: number;
	sonstigeRente: number;
	sparrate: number;
	beginnSpar: number;
	endeSpar: number;
	steigerungSpar: number;
	kapital: number;
	steigerungKapt: number;
	einkommenssteigerung: number;
	profilRuEnde: number;

	constructor(alter: number, personAnrede: string, profilAlterRuzp: number, profilGvsAltersrenteMtl: number, einkommenNekG: number, gewuenschteRente: number, inflation: number, steigerungGes: number, sonstigeRente: number, sparrate: number, beginnSpar: number, endeSpar: number, steigerungSpar: number, kapital: number, steigerungKapt: number, einkommenssteigerung: number, profilRuEnde: number) {
		this.alter = alter;
		this.personAnrede = personAnrede;
		this.profilAlterRuzp = profilAlterRuzp;
		this.profilGvsAltersrenteMtl = profilGvsAltersrenteMtl;
		this.einkommenNekG = einkommenNekG;
		this.gewuenschteRente = gewuenschteRente;
		this.inflation = inflation;
		this.steigerungGes = steigerungGes;
		this.sonstigeRente = sonstigeRente;
		this.sparrate = sparrate;
		this.beginnSpar = beginnSpar;
		this.endeSpar = endeSpar;
		this.steigerungSpar = steigerungSpar;
		this.kapital = kapital;
		this.steigerungKapt = steigerungKapt;
		this.einkommenssteigerung = einkommenssteigerung;
		this.profilRuEnde = profilRuEnde;
	}
}

export class TeaserResponseModel {
	dauerBisRente: number;
	bedarf: number;
	luecke: number;
	lebenserwartung: number;
	sparrate: number;
	definoBedarf: number;
	bruttoGes: number;
	nettoGes: number;
	bruttoPriv: number;
	nettoPriv: number;
	nettoKapt: number;
	bruttoKapt: number;
	nettoall: number;
	bruttoall: number;
	bedarfL: number;
	lueckeL: number;
	definoBedarfL: number;
	bruttoGesL: number;
	nettoGesL: number;
	bruttoPrivL: number;
	nettoPrivL: number;
	nettoKaptL: number;
	bruttoKaptL: number;
	nettoallL: number;
	bruttoallL: number;
	dayOfMonth: number;
	sparrateZiel: number;
	bruttoPrivKapt: number;
	targetAchievementLevel: number;
	bruttotluecke: number;
	bruttobedarf: number;
}

export class TeaserDataModel {
	opt: TeaserModel[];
	addInitYear: number = 25;

	constructor() {
		this.opt = [
			{
				label: 'STR_FIELD_ALTER',
				info: null,
				id: 'alter',
				values: [35, 18, 64, 1],
				value: 35,
				order: 1,
				allocated: 'user',
				mandatory: true,
				type: 'range',
				symbol: 'age',
				show: 'show'
			},
			{
				label: 'STR_FIELD_PERSON_ANREDE',
				info: null,
				id: 'personAnrede',
				values: [1, 1, 2],
				value: 1,
				order: 2,
				allocated: 'user',
				mandatory: true,
				type: 'checkbox',
				symbol: null,
				show: 'show'
			},
			{
				label: 'STR_FIELD_PROFIL_ALTER_RUZP',
				info: null,
				id: 'profilAlterRuzp',
				values: [67, 63, 67, 1],
				value: 67,
				order: 3,
				allocated: 'user',
				mandatory: true,
				type: 'range',
				symbol: 'age',
				show: 'show'
			},
			{
				label: 'STR_FIELD_FAKE_DOC',
				info: 'STR_FIELD_FAKE_DOC_INFO',
				id: 'fakeDoc',
				values: [0, 0, 4000, 100],
				value: 0,
				order: 1,
				allocated: 'document',
				mandatory: false,
				type: 'range',
				symbol: 'currency',
				show: 'show'
			},
			{
				label: 'STR_FIELD_PROFIL_ALTER_RENTE_MTL',
				info: 'STR_FIELD_PROFIL_ALTER_RENTE_MTL_INFO',
				id: 'profilGvsAltersrenteMtl',
				values: [0, 0, 4000, 100],
				value: 0,
				order: 1,
				allocated: 'box1',
				mandatory: true,
				type: 'range',
				symbol: 'currency',
				show: 'show'
			},
			{
				label: 'STR_FIELD_PROFIL_EINKOMMEN_KG',
				info: 'STR_FIELD_PROFIL_EINKOMMEN_KG_INFO',
				id: 'einkommenNekG',
				values: [0, 0, 10000, 100],
				value: 0,
				order: 1,
				allocated: 'box1',
				mandatory: true,
				type: 'range',
				symbol: 'currency',
				show: 'show'
			},
			{
				label: 'STR_FIELD_PROFIL_GEWUENSCHTE_RENTE',
				info: 'STR_FIELD_PROFIL_GEWUENSCHTE_RENTE_INFO',
				id: 'gewuenschteRente',
				values: [0, 0, 10000, 100],
				value: 0,
				order: 3,
				allocated: 'box1',
				mandatory: false,
				type: 'range',
				symbol: 'currency',
				show: 'show'
			},
			{
				label: 'STR_FIELD_INFLATION',
				info: 'STR_FIELD_INFLATION_INFO',
				id: 'inflation',
				values: [10, 0, 25, 2],
				value: 10,
				order: 4,
				allocated: 'box3',
				mandatory: false,
				type: 'range',
				symbol: 'percent',
				show: 'true'
			},
			{
				label: 'STR_FIELD_STEIGERUNG_GES',
				info: 'STR_FIELD_STEIGERUNG_GES_INFO',
				id: 'steigerungGes',
				values: [8, 0, 20, 2],
				value: 8,
				order: 5,
				allocated: 'box3',
				mandatory: false,
				type: 'range',
				symbol: 'percent',
				show: 'show'
			},
			{
				label: 'STR_FIELD_SONSTIGE_RENTE',
				info: 'STR_FIELD_SONSTIGE_RENTE_INFO',
				id: 'sonstigeRente',
				values: [0, 0, 5000, 100],
				value: 0,
				order: 6,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'currency',
				show: 'show'
			},
			{
				label: 'STR_FIELD_SPARRATE',
				info: null,
				id: 'sparrate',
				values: [0, 0, 5000, 100],
				value: 0,
				order: 6,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'currency',
				show: 'hidden'
			},
			{
				label: 'STR_FIELD_BEGINN_SPARRATE',
				info: null,
				id: 'beginnSpar',
				values: [new Date().getFullYear(), new Date().getFullYear(), new Date(new Date().getFullYear() - 100)],
				value: 0,
				order: 8,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'year',
				show: 'hidden'
			},
			{
				label: 'STR_FIELD_ENDE_SPARRATE',
				info: null,
				id: 'endeSpar',
				values: [new Date().getFullYear(), new Date().getFullYear()],
				value: 0,
				order: 9,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'year',
				show: 'hidden'
			},
			{
				label: 'STR_FIELD_STEIGERUNG_SPAR',
				info: null,
				id: 'steigerungSpar',
				values: [35, 0, 60, 5],
				value: 0,
				order: 10,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'percent',
				show: 'hidden'
			},
			{
				label: 'STR_FIELD_KAPITAL',
				info: 'STR_FIELD_KAPITAL_INFO',
				id: 'kapital',
				values: [0, 0, 250000, 5000],
				value: 0,
				order: 11,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'currency',
				show: 'show'
			},
			{
				label: 'STR_FIELD_STEIGERUNG_KAPT',
				info: 'STR_FIELD_STEIGERUNG_KAPT_INFO',
				id: 'steigerungKapt',
				values: [25, 0, 60, 5],
				value: 0,
				order: 12,
				allocated: 'box2',
				mandatory: false,
				type: 'range',
				symbol: 'percent',
				show: 'show'
			}
		]
	}
}

export class TeaserRequestPDFModel {
	lebenserwartung: string = "0";
	targetAchievementLevel: string = "0";
	dayOfMonth: number = 0;
	alter: number = 0;
	personAnrede: string = "männllich"; //1: männllich, 2: weiblich
	einkommenNekG: string = "0";
	profilAlterRuzp: string = "0";
	gewuenschteRente: string = "0";
	profilGvsAltersrenteMtl: string = "0";
	nettoPriv: string = "0";
	kapital: string = "0";
	bruttoGes: string = "0";
	bruttoPrivKapt: string = "0";
	bruttoall: string = "0";
	sonstigeRente: string = "0";
	lueckeL: string = "0";
	sparrateZiel: string = "0";
	bruttoPriv: string = "0";
	nettoallL: string = "0";
	inflation: string = "0";
	steigerungGes: string = "0";
}


export class DefinoInputRentenTool {
	profilRuEnde: number;
	personAnrede: string;
	gesetLicheRenten: number;
	profilAvInflation: number;
	rahmenInflation: number;
	profilAvKaptZins: number;
	rahmenRenditeKlasse1: number;
	profilAlterRuzp: number;
	einkommenSteigerung: number;
	einkommenNekG: number;
	einkommenBesoldung: number;
	einkommenWegFallNek: number;
	einkommenFamZuschlag: number;
	personGebDat: string;
	privatePension: number;
}



// WEBPACK FOOTER //
// ./src/components/teaser/teaser.model.ts